module.exports = __webpack_public_path__ + "static/media/redeem-code-icon.94e6a407.svg";